import Inbox from '@/modules/smsinbox/views/InboxView.vue';

export const SmsInboxRoutes = [
    {
        path: '/inbox',
        component: Inbox,
    }
];
